/* Dominique rebuild: small, dependency-free behaviours. No WebGL. */
(function () {
  "use strict";
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Lock zoom on mobile ----
     iOS Safari ignores the viewport user-scalable flag, so cancel the pinch gesture
     directly. gesture* events fire only for pinch (not scroll), and the multi-touch
     touchmove guard covers browsers without gesture events. Double-tap zoom is killed
     by touch-action: manipulation in CSS, so normal scrolling and taps are untouched. */
  (function lockZoom() {
    function block(e) { e.preventDefault(); }
    document.addEventListener("gesturestart", block, { passive: false });
    document.addEventListener("gesturechange", block, { passive: false });
    document.addEventListener("gestureend", block, { passive: false });
    document.addEventListener("touchmove", function (e) {
      if (e.touches && e.touches.length > 1) { e.preventDefault(); }
    }, { passive: false });
  })();

  /* ---- Hero CTA: Rhode direction-aware fill ----
     On hover a white panel slides IN from the edge the cursor enters and OUT toward the
     edge it leaves (the panel is a ::before driven by --fill-x / --fill-y). On touch it
     fills from the bottom, held briefly so the animation reads before the link navigates. */
  (function heroCtaFill() {
    function edge(e, el) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      if (Math.abs(x) > Math.abs(y)) return x > 0 ? { x: "101%", y: "0%" } : { x: "-101%", y: "0%" };
      return y > 0 ? { x: "0%", y: "101%" } : { x: "0%", y: "-101%" };
    }
    function setVars(el, d) { el.style.setProperty("--fill-x", d.x); el.style.setProperty("--fill-y", d.y); }
    /* Delegated with mouseover/mouseout + relatedTarget (the enter/leave emulation) so the
       effect keeps working when the theme editor re-renders the hero section with new DOM. */
    document.addEventListener("mouseover", function (e) {
      var cta = e.target.closest(".r3hero__cta");
      if (!cta || (e.relatedTarget && cta.contains(e.relatedTarget))) return;
      var d = edge(e, cta);
      cta.classList.add("no-fill-anim");      // jump to the entry edge with no transition
      setVars(cta, d);
      void cta.offsetWidth;                   // force reflow
      cta.classList.remove("no-fill-anim");
      cta.classList.add("is-filling");
      requestAnimationFrame(function () { setVars(cta, { x: "0%", y: "0%" }); });
    });
    document.addEventListener("mouseout", function (e) {
      var cta = e.target.closest(".r3hero__cta");
      if (!cta || (e.relatedTarget && cta.contains(e.relatedTarget))) return;
      var d = edge(e, cta);                   // animate out toward the exit edge
      cta.classList.remove("is-filling");
      setVars(cta, d);
    });
    document.addEventListener("touchstart", function (e) {
      var cta = e.target.closest(".r3hero__cta");
      if (!cta) return;
      cta.classList.remove("no-fill-anim");
      cta.classList.add("is-filling");
      setVars(cta, { x: "0%", y: "0%" });
    }, { passive: true });
    function release(e) {
      var cta = e.target.closest ? e.target.closest(".r3hero__cta") : null;
      if (!cta) return;
      setTimeout(function () { cta.classList.remove("is-filling"); setVars(cta, { x: "0%", y: "101%" }); }, 260);
    }
    document.addEventListener("touchend", release);
    document.addEventListener("touchcancel", release);
  })();

  /* ---- Announcement bar: rotate messages, with pause ---- */
  (function announcements() {
    var bar = document.querySelector("[data-announcement]");
    if (!bar) return;
    var items = bar.querySelectorAll(".announcement__item");
    if (items.length < 2) return;
    var i = 0;
    var paused = false;
    var timer = null;
    function show(n) {
      items.forEach(function (el, idx) { el.classList.toggle("is-active", idx === n); });
    }
    function tick() { if (paused) return; i = (i + 1) % items.length; show(i); }
    function start() { if (!reduceMotion) timer = setInterval(tick, 4000); }
    var btn = bar.querySelector("[data-announcement-toggle]");
    if (btn) {
      btn.addEventListener("click", function () {
        paused = !paused;
        btn.setAttribute("aria-label", paused ? "Play announcements" : "Pause announcements");
        btn.style.opacity = paused ? "1" : "";
      });
    }
    start();
  })();

  /* ---- Header: solid + shadow once scrolled ----
     The header node is re-queried on every scroll tick (cheap getElementById) so the
     effect survives the theme editor re-rendering the header section with fresh DOM. */
  (function header() {
    function onScroll() {
      var el = document.getElementById("siteHeader");
      if (el) el.classList.toggle("is-scrolled", window.scrollY > 8);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  })();

  /* ---- Mobile nav drawer ----
     Fully delegated (no per-node bindings) so the drawer keeps working after the theme
     editor re-renders the header section. The open state also goes on <html>: html is the
     page scroll container (html{overflow-x:hidden} in dq-base), so body{overflow:hidden}
     alone never actually locked the page behind the drawer. */
  (function mobileNav() {
    function setOpen(on) {
      document.body.classList.toggle("nav-open", on);
      document.documentElement.classList.toggle("nav-open", on);
      var btn = document.querySelector("[data-nav-open]");
      if (btn) btn.setAttribute("aria-expanded", on ? "true" : "false");
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-nav-open]")) { setOpen(true); return; }
      if (e.target.closest("[data-nav-close]")) { setOpen(false); }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") setOpen(false); });
    // iOS back-forward cache can restore a page with the drawer still open and the
    // scroll lock on (the whole site then feels stuck). Always reset on restore.
    window.addEventListener("pageshow", function (e) { if (e.persisted) setOpen(false); });
    // THEME EDITOR: selecting a Mobile menu link block opens the drawer so the
    // highlight is visible; deselecting closes it again.
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:block:select", function (e) {
        if (e.target.closest && e.target.closest("#mobileNav")) setOpen(true);
      });
      document.addEventListener("shopify:block:deselect", function (e) {
        if (e.target.closest && e.target.closest("#mobileNav")) setOpen(false);
      });
    }
  })();

  /* ---- Header bag count: live update after AJAX add/remove ----
     The stock Pipeline header module (headerTotals) only initialises for sections marked
     data-section-type="header", which the dq header is not, so the badge froze at its
     server-rendered value. Pipeline's cart code dispatches theme:cart:change on document
     with the cart in event.detail; mirror the count into the dq badge. Queried at event
     time so it survives header re-renders. */
  document.addEventListener("theme:cart:change", function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (!cart || typeof cart.item_count === "undefined") return;
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
    });
  });

  /* ---- Scrollbar width -> CSS var ----
     100vw includes the classic scrollbar on Windows desktops, so full-bleed rows sized
     with 100vw overflow by the scrollbar width. Publish the real gutter as --dq-scrollbar-w
     for the CSS to subtract. 0px on overlay-scrollbar platforms (macOS, phones). */
  (function scrollbarVar() {
    function set() {
      var w = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty("--dq-scrollbar-w", (w > 0 ? w : 0) + "px");
    }
    set();
    window.addEventListener("resize", set, { passive: true });
  })();

  /* ---- Scroll reveal ---- */
  (function reveal() {
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    function revealIn(root) {
      (root || document).querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-in"); });
    }
    // In the Shopify theme editor the scroll observer does not re-run when a section is
    // re-rendered on edit, so the freshly injected .reveal nodes were left stranded at
    // opacity:0 and the section looked like it vanished while typing. Reduced motion and
    // browsers without IntersectionObserver take the same always-visible path. In all of
    // these cases show everything up front AND again whenever a section (re)loads.
    /* Watch for .reveal nodes injected OUTSIDE section loads too: the collection page
       replaces its whole product grid via innerHTML on every filter / sort / AJAX
       pagination, and those fresh cards were never observed, so they sat at opacity:0
       (an invisible grid after any filter). Any dynamically added .reveal now gets the
       same treatment as one present at load. */
    function watchDynamic(handle) {
      if (!("MutationObserver" in window) || !document.body) return;
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if ((node.classList && node.classList.contains("reveal")) ||
                (node.querySelector && node.querySelector(".reveal"))) {
              handle(node.parentNode || document);
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    if (inEditor || reduceMotion || !("IntersectionObserver" in window)) {
      revealIn(document);
      document.addEventListener("shopify:section:load", function (e) { revealIn(e.target); });
      watchDynamic(revealIn);
      return;
    }
    // Fade elements in ONCE as they enter the viewport, then stop observing them.
    // Never toggle back off: un-revealing on exit made the reveal's own translateY
    // move edge-straddling elements back across the threshold, which strobed them
    // (rapid fade in/out at the top of the screen at certain scroll positions).
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });
    function observe(root) {
      (root || document).querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
    }
    // Safety net: reveal anything already in view on load (covers IO first-frame timing).
    function initialReveal(root) {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      (root || document).querySelectorAll(".reveal").forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) el.classList.add("is-in");
      });
    }
    observe(document);
    initialReveal(document);
    window.addEventListener("load", function () { initialReveal(document); });
    // Re-observe sections the theme editor re-renders (or any dynamically loaded section)
    // so their .reveal nodes are never stranded hidden after an edit.
    document.addEventListener("shopify:section:load", function (e) {
      observe(e.target);
      initialReveal(e.target);
    });
    // And anything injected outside section loads (AJAX collection grid, apps).
    watchDynamic(function (root) { observe(root); initialReveal(root); });
  })();

  /* ---- Add-to-cart is handled by the theme's locked product form
     (snippets/product-add-button-form.liquid + theme.js AJAX + the mobile-app sync).
     rebuild4's mock cart was removed so it does not intercept the real form submit. ---- */

  /* ---- Read more: clamp long PDP description with a toggle ----
     Marks each [data-dq-readmore] collapsible only when its body actually overflows the
     CSS clamp, so short descriptions never show the button. Delegated toggle + re-measure
     on section load, so it survives theme-editor re-renders. ---- */
  (function readMore() {
    function measure(root) {
      (root || document).querySelectorAll("[data-dq-readmore]").forEach(function (rm) {
        if (rm.classList.contains("is-expanded")) return;
        var body = rm.querySelector(".dq-readmore__body");
        if (!body) return;
        rm.classList.add("is-collapsible"); // apply the clamp so overflow can be measured
        if (body.scrollHeight <= body.clientHeight + 4) rm.classList.remove("is-collapsible");
      });
    }
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-dq-readmore-toggle]");
      if (!btn) return;
      var rm = btn.closest("[data-dq-readmore]");
      if (!rm) return;
      var expanded = rm.classList.toggle("is-expanded");
      btn.textContent = expanded ? "Read less" : "Read more";
      btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
    function measureAll() { measure(document); }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", measureAll);
    } else { measureAll(); }
    window.addEventListener("load", measureAll);
    document.addEventListener("shopify:section:load", function (e) { measure(e.target); });
  })();

  /* ---- Quiz opener placeholder (overlay added later) ---- */
  (function quiz() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-open-quiz]");
      if (!btn) return;
      var overlay = document.getElementById("routineQuiz");
      if (overlay) overlay.classList.add("is-open");
    });
  })();

  /* ---- Product card shades: "+N" expander, recolour-on-select, photo swap ----
     One delegated listener for every product card (bestsellers carousel + collection
     grids + related). Selecting a swatch tints the card to a soft wash of the shade
     and, when the shade has an image, swaps the main photo. The homepage lineup tiles
     have their own scoped script; this covers the shared product-card partial. */
  (function productCardShades() {
    function tint(hex) {
      var h = (hex || "").replace("#", "");
      if (h.length === 3) { h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; }
      var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
      if (isNaN(r) || isNaN(g) || isNaN(b)) { return ""; }
      // 16% shade over 84% white: a pale wash of the selected shade.
      r = Math.round(r * 0.16 + 255 * 0.84);
      g = Math.round(g * 0.16 + 255 * 0.84);
      b = Math.round(b * 0.16 + 255 * 0.84);
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
    // Selected shade line above the dots (dq-product-card renders it, Red 25 Sep 2026:
    // "it is hard to know what color you choose"). A name writes it in ink; no name (or
    // useHint) restores the soft placeholder the snippet stored on the element.
    function setShadeName(card, name, useHint) {
      var el = card.querySelector("[data-pc-shade-name]");
      if (!el) return;
      if (useHint || !name) {
        el.textContent = el.getAttribute("data-pc-shade-hint") || "";
        el.classList.add("is-hint");
      } else {
        el.textContent = name;
        el.classList.remove("is-hint");
      }
    }
    // Pointer devices preview the hovered shade's name and fall back to the picked one
    // (or the placeholder) on leave. Touch devices skip this: a tap fires mouseover then
    // click, and the click handler writes the name anyway.
    if (window.matchMedia && window.matchMedia("(hover: hover)").matches) {
      document.addEventListener("mouseover", function (e) {
        var sw = e.target.closest("[data-pc-swatch]");
        if (!sw) return;
        var card = sw.closest(".product-card");
        if (card) setShadeName(card, sw.getAttribute("data-shade-name"), false);
      });
      document.addEventListener("mouseout", function (e) {
        var sw = e.target.closest("[data-pc-swatch]");
        if (!sw) return;
        var card = sw.closest(".product-card");
        if (!card) return;
        var picked = card.querySelector('[data-pc-swatch][aria-pressed="true"]');
        if (picked) { setShadeName(card, picked.getAttribute("data-shade-name"), false); }
        else { setShadeName(card, null, true); }
      });
    }
    document.addEventListener("click", function (e) {
      var more = e.target.closest("[data-pc-more]");
      if (more) {
        var grp = more.closest("[data-pc-shades]");
        if (grp) {
          // Toggle: "+N" expands the collapsed swatches, the minus collapses them again.
          var expanded = more.getAttribute("aria-expanded") === "true";
          grp.querySelectorAll(".product-card__swatch--extra").forEach(function (s) {
            if (expanded) { s.setAttribute("hidden", ""); } else { s.removeAttribute("hidden"); }
          });
          more.setAttribute("aria-expanded", expanded ? "false" : "true");
          more.textContent = expanded ? more.getAttribute("data-more-label") : "-";
          more.setAttribute("aria-label", expanded ? ("Show " + more.getAttribute("data-more-count") + " more shades") : "Show fewer shades");
        }
        return;
      }
      var sw = e.target.closest("[data-pc-swatch]");
      if (!sw) return;
      var group = sw.closest("[data-pc-shades]");
      var card = sw.closest(".product-card");
      if (!group || !card) return;
      group.querySelectorAll("[data-pc-swatch]").forEach(function (s) { s.setAttribute("aria-pressed", "false"); });
      sw.setAttribute("aria-pressed", "true");
      setShadeName(card, sw.getAttribute("data-shade-name"), false);
      var t = tint(sw.getAttribute("data-shade-hex"));
      if (t) { card.style.background = t; }
      var src = sw.getAttribute("data-shade-img");
      var img = card.querySelector(".product-card__img--main");
      if (src && img) {
        // The card image now carries a srcset (dq-product-card); a bare src change would be
        // ignored while srcset is present, so drop it before pointing at the shade photo.
        img.removeAttribute("srcset");
        img.src = src;
        // Suppress the hover-alt photo so the picked shade is visible on desktop
        // (the cursor hovers the card while clicking, which showed the alt on top).
        card.classList.add("pc-shade-picked");
      }
      // Shopify: point the card's locked add-to-bag form at the selected variant so
      // "Add to bag" adds the chosen shade (data-variant-id set in dq-product-card).
      var vid = sw.getAttribute("data-variant-id");
      if (vid) {
        var input = card.querySelector('form input[name="id"]');
        if (input) { input.value = vid; }
      }
      // Button state machine over the spans dq-product-card renders (choose / ready /
      // soldout). Picking any shade clears the choose gate; a sold-out shade parks the
      // button disabled so a dead variant can never be submitted.
      var addBtn = card.querySelector("[data-add-to-cart]");
      // A whole-product sold-out card (data-pc-soldout, rendered server side) stays parked
      // whatever swatch is tapped; only per-shade availability drives the state machine.
      if (addBtn && !addBtn.hasAttribute("data-pc-soldout")) {
        addBtn.removeAttribute("data-needs-shade");
        var state = sw.hasAttribute("data-soldout") ? "soldout" : "ready";
        var spans = addBtn.querySelectorAll("[data-pc-state]");
        spans.forEach(function (s) { s.hidden = s.getAttribute("data-pc-state") !== state; });
        addBtn.disabled = state === "soldout";
      }
    });

    // Shade gate: a multi-shade card's button opens the shade-picker MODAL instead of
    // submitting (the shopper must choose a color first, like the classic site's popup).
    // Capture phase beats the locked form's submit.
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-add-to-cart][data-needs-shade]");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest(".product-card");
      if (card) openShadeModal(card);
    }, true);

    // Shade-picker modal: built on demand FROM the clicked card's own swatch data, and
    // it adds to cart by remote-controlling the card (picks the card's real swatch,
    // then clicks the card's real button), so the LOCKED form stays the only cart path.
    var modalCfg = window.dqCardModal || {};
    var shadeModal = null, modalCard = null, modalReturnFocus = null;
    function buildShadeModal() {
      if (shadeModal) return shadeModal;
      var wrap = document.createElement("div");
      wrap.className = "dq-shade-modal";
      wrap.setAttribute("hidden", "");
      wrap.innerHTML =
        '<div class="dq-shade-modal__overlay" data-dqsm-close></div>' +
        '<div class="dq-shade-modal__sheet" role="dialog" aria-modal="true">' +
          '<button type="button" class="dq-shade-modal__close" data-dqsm-close aria-label="Close">&#215;</button>' +
          '<p class="dq-shade-modal__title"></p>' +
          '<div class="dq-shade-modal__row">' +
            '<div class="dq-shade-modal__media"><img alt="" width="264" height="264" loading="lazy"></div>' +
            '<div class="dq-shade-modal__info">' +
              '<p class="dq-shade-modal__name"></p>' +
              '<p class="dq-shade-modal__option"></p>' +
              '<div class="dq-shade-modal__dots" role="group"></div>' +
              '<p class="dq-shade-modal__picked" aria-live="polite"></p>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="dq-shade-modal__add" data-dqsm-add disabled></button>' +
        '</div>';
      document.body.appendChild(wrap);
      wrap.addEventListener("click", function (e) {
        if (e.target.closest("[data-dqsm-close]")) closeShadeModal();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !wrap.hasAttribute("hidden")) closeShadeModal();
      });
      shadeModal = wrap;
      return wrap;
    }
    function closeShadeModal() {
      if (!shadeModal) return;
      shadeModal.setAttribute("hidden", "");
      document.documentElement.classList.remove("dq-modal-open");
      if (modalReturnFocus && modalReturnFocus.focus) modalReturnFocus.focus();
      modalCard = null;
    }
    function openShadeModal(card) {
      var m = buildShadeModal();
      modalCard = card;
      modalReturnFocus = document.activeElement;
      var name = ((card.querySelector(".product-card__name") || {}).textContent || "").trim();
      m.querySelector(".dq-shade-modal__sheet").setAttribute("aria-label", modalCfg.title || "Choose the desired product options");
      m.querySelector(".dq-shade-modal__title").textContent = modalCfg.title || "Choose the desired product options";
      m.querySelector(".dq-shade-modal__name").textContent = name;
      m.querySelector(".dq-shade-modal__option").textContent = modalCfg.option || "Color";
      m.querySelector(".dq-shade-modal__picked").textContent = "";
      var img = m.querySelector(".dq-shade-modal__media img");
      var mainImg = card.querySelector(".product-card__img--main");
      img.src = mainImg ? (mainImg.currentSrc || mainImg.src) : "";
      img.alt = name;
      var addBtn = m.querySelector("[data-dqsm-add]");
      addBtn.disabled = true;
      addBtn.textContent = modalCfg.add || "Add to bag";
      var dots = m.querySelector(".dq-shade-modal__dots");
      dots.innerHTML = "";
      card.querySelectorAll("[data-pc-swatch]").forEach(function (sw) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "dq-shade-modal__dot" + (sw.hasAttribute("data-soldout") ? " is-soldout" : "");
        dot.style.background = sw.style.background;
        dot.title = sw.getAttribute("title") || sw.getAttribute("data-shade-name") || "";
        dot.setAttribute("aria-label", sw.getAttribute("aria-label") || dot.title);
        dot.addEventListener("click", function () {
          dots.querySelectorAll(".dq-shade-modal__dot").forEach(function (d) { d.classList.remove("is-picked"); });
          dot.classList.add("is-picked");
          var shadeImg = sw.getAttribute("data-shade-img");
          if (shadeImg) { img.src = shadeImg; }
          m.querySelector(".dq-shade-modal__picked").textContent = sw.getAttribute("data-shade-name") || "";
          sw.click();
          if (sw.hasAttribute("data-soldout")) {
            addBtn.disabled = true;
            addBtn.textContent = modalCfg.soldout || "Sold out";
          } else {
            addBtn.disabled = false;
            addBtn.textContent = modalCfg.add || "Add to bag";
          }
        });
        dots.appendChild(dot);
      });
      addBtn.onclick = function () {
        var realBtn = modalCard && modalCard.querySelector("[data-add-to-cart]");
        closeShadeModal();
        if (realBtn && !realBtn.disabled && !realBtn.hasAttribute("data-needs-shade")) { realBtn.click(); }
      };
      m.removeAttribute("hidden");
      document.documentElement.classList.add("dq-modal-open");
      m.querySelector(".dq-shade-modal__close").focus();
    }

    // Mobile drawer SHOP accordion (delegated: survives editor re-renders).
    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-mnav-shop-toggle]");
      if (!t) return;
      var item = t.closest("[data-mnav-shop]");
      var panel = item && item.querySelector("[data-mnav-shop-panel]");
      if (!panel) return;
      var open = panel.hasAttribute("hidden");
      if (open) { panel.removeAttribute("hidden"); } else { panel.setAttribute("hidden", ""); }
      item.classList.toggle("is-open", open);
      t.setAttribute("aria-expanded", open ? "true" : "false");
    });
  })();

  /* ---- PDP: scroll the product gallery into view on shade click ----
     When a colour swatch is tapped on the product page, smooth-scroll so the main image
     is visible and the shopper sees the new shade. Delegated, additive, and PDP-scoped:
     it only fires when the click is inside a locked Pipeline swatch (.swatch__button) or a
     colour label within .product__block__variants, AND a gallery wrapper exists, so it is a
     no-op everywhere else. It never preventDefaults, so the locked variant change still runs.
     Gallery selector: .product__media__wrapper (Pipeline's product media column; falls back to
     the slideshow / a single media slide). The sticky header is offset via scroll-margin-top
     so the image is not tucked under it. */
  (function pdpSwatchScroll() {
    /* The gallery is looked up at CLICK time (not cached) so the behaviour survives the
       theme editor re-rendering the product section with fresh DOM. */
    function findGallery() {
      return document.querySelector(".product__media__wrapper")
        || document.querySelector("[data-product-slideshow]")
        || document.querySelector(".product__media");
    }
    document.addEventListener("click", function (e) {
      // A locked Pipeline swatch button, or a colour label/radio inside the variant block.
      var hit = e.target.closest(".product__block__variants .swatch__button")
        || e.target.closest(".product__block__variants label")
        || e.target.closest(".product__block__variants .radio__button")
        || e.target.closest(".product__block__variants .swatch__label");
      if (!hit) return; // not a PDP shade control -> ignore
      var gallery = findGallery();
      if (!gallery) return; // off the PDP, do nothing
      // Keep the scrolled-to image clear of the sticky header (var(--header-h) is 76px).
      var headerH = 76;
      var hv = getComputedStyle(document.documentElement).getPropertyValue("--header-h");
      if (hv) { var n = parseInt(hv, 10); if (!isNaN(n)) headerH = n; }
      gallery.style.scrollMarginTop = (headerH + 16) + "px";
      // Let the locked variant-change handler run first, then scroll. Never preventDefault.
      requestAnimationFrame(function () {
        var behavior = reduceMotion ? "auto" : "smooth";
        gallery.scrollIntoView({ behavior: behavior, block: "start" });
      });
    });
  })();
  // dq-owned PDP accordion toggle (Pipeline 8.2.0 removed the theme's data-accordion-trigger
  // module, leaving the dq buy-box accordions dead; the collapse/expand CSS lives in
  // dq-pdp.css keyed on accordion-is-open). Delegated: survives editor re-renders.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".dq-pdp-accordion [data-accordion-trigger]");
    if (!btn) return;
    var open = btn.classList.toggle("accordion-is-open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    // Live parity: the 8.1.1 module closed siblings in the same group on open.
    if (open) {
      var group = btn.closest("[data-accordion-group]");
      if (group) {
        group.querySelectorAll("[data-accordion-trigger].accordion-is-open").forEach(function (other) {
          if (other !== btn) {
            other.classList.remove("accordion-is-open");
            other.setAttribute("aria-expanded", "false");
          }
        });
      }
    }
  });
})();
